/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPccPushStatus200ResponseData
 */
export interface ResetPccPushStatus200ResponseData {
    /**
     * 
     */
    message?: string;
}

/**
 * Check if a given object implements the ResetPccPushStatus200ResponseData interface.
 */
export function instanceOfResetPccPushStatus200ResponseData(value: object): value is ResetPccPushStatus200ResponseData {
    return true;
}

export function ResetPccPushStatus200ResponseDataFromJSON(json: any): ResetPccPushStatus200ResponseData {
    return ResetPccPushStatus200ResponseDataFromJSONTyped(json, false);
}

export function ResetPccPushStatus200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPccPushStatus200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ResetPccPushStatus200ResponseDataToJSON(json: any): ResetPccPushStatus200ResponseData {
    return ResetPccPushStatus200ResponseDataToJSONTyped(json, false);
}

export function ResetPccPushStatus200ResponseDataToJSONTyped(value?: ResetPccPushStatus200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

